import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-location_fill",
  "use": "icon-location_fill-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-location_fill\"><path d=\"M955.68 26.848L21.12 393.984a32 32 0 0 0 2.304 60.352L441.12 582.848l128.512 417.696a32 32 0 0 0 60.352 2.304L997.152 68.32a32 32 0 0 0-41.472-41.44z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol